



























































































































































































































































































































































































































































































































































































































































































































































































































import Vue, { PropOptions } from 'vue';
import API from '@/api/common';
import util from '@/components/util';
import NOC from '@/class/common/const';
import {IAPP} from '@/class/models/views/app';
import * as models from '@/class/models/views/alert';

import SelectBoxV3, {IOption} from '@/components/util/SelectBoxV3.vue';
import MultiSelectSearchBox from '@/components/util/MultiSelectSearchBox.vue';
import SideMenuAlert from '@/components/util/SideMenuAlert.vue';

// validation
import * as validation from '@/personal/validation';
import VariableInput, * as vi from '@/components/util/VariableInput.vue';

// datepicker
import DatePicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale';
import { ISelectOption } from '@/class/models/views/setting/users';

import * as alertModels from '@/class/models/views/alert';
import * as Talert from '@/class/models/typed/alert';

import ModalDeleteConfirm from '@/components/util/ModalDeleteConfirm.vue';
import ModalFormDataCheck from '@/components/util/ModalFormDataCheck.vue';
import { IAlertSettingUnit } from '@/class/models/views/alert';
import { IRREGULAR_OP_COUNT_UPPER_DEFAULT } from '@/class/common/const/alert-const';


interface IAppOption extends IOption {
  appChecked: boolean;
  windowChecked: boolean;
}

export default Vue.extend({
  name: 'Alert',
  props: {
    appData: Object as PropOptions<IAPP>,
  },
  components: {
    ...util, VariableInput, DatePicker, SelectBoxV3, MultiSelectSearchBox, SideMenuAlert, ModalDeleteConfirm, ModalFormDataCheck,
  },
  data() {
    return {
      onload: false,
      alertData: new models.CAlertSetting(),
      editAlertData: new models.CAlertSetting(),
      alert36Array: [] as models.CAlert36Setting[],
      editAlert36Array: [] as models.CAlert36Setting[],
      bannedApps: [] as models.CBannedApp[],
      editBannedApps: [] as models.CBannedApp[],
      selectedJobs: [] as IOption[],
      selectedJobValue: '',
      hoverJobIndex: -1,
      mode: NOC.SETTING.MODE.NORMAL,
      editType: '',
      current36Index: -1,
      dialogJobSelect: false,
      dialogDelete36: false,
      // validation
      items: [
        // {key: 'perdayLimit', name: '', type: vi.INPUT_TYPE.NUMBER, required: false, error: '', min: 0, max: 23, disabled: true},
        // {key: 'permonthLimit', name: '', type: vi.INPUT_TYPE.NUMBER, required: false, error: '', min: 0, max: 743, disabled: true},
        // {key: 'peryearLimit', name: '', type: vi.INPUT_TYPE.NUMBER, required: false, error: '', min: 0, max: 8783, disabled: true},
        {key: 'intervalLimit', name: '', type: vi.INPUT_TYPE.NUMBER, required: false, error: '', min: 1, max: 36}, // 24 + 12
        {key: 'irregularOpCountUpper', name: '', type: vi.INPUT_TYPE.NUMBER, required: false, error: '', min: 900, max: 30000},
        // {key: 'startdate', name: '', type: vi.INPUT_TYPE.TEXT, required: false, error: ''},
      ] as vi.IVariableInput[],
      appitems: [] as vi.IVariableInput[],
      DatePickerDate: 'M月d日',
      ja,
      alertList: [] as Talert.INewsAlert[],
      minAlertID: 0,
      showDetaile: false,
      formDataChangeFlgModal: false,
      intervalLimit: '',
      editIntervalLimit: '',
      irregularOpCountUpper: '',
      editIrregularOpCountUpper: '',
    };
  },
  directives: {
    DatePicker,
  },
  computed: {
    MODE_NORMAL(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NORMAL);
    },
    MODE_EDIT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT);
    },
    EDIT_WORK(): boolean {
      return this.editType === 'WORK';
    },
    EDIT_APP(): boolean {
      return this.editType === 'APP';
    },
    EDIT_OPERATION(): boolean {
      return this.editType === 'OPERATION';
    },
    JOBArray(): IOption[] {
      return NOC.JOB.JOBArray;
    },
    MONTH_FIRST_OPTIONS(): IOption[] {
      const options = [ NOC.SELECT.NOSELECT ];
      for (let i = 1; i <= 31; i++) {
        options.push({value: i, text: `毎月${i}日`});
      }
      return options;
    },
    SETTINGS_36_TEMPLATE(): models.IAlertSettingUnit[][] {
      // backend/src/convert/alert-setting-36と合わせる
      return [
        [
          {key: 'ordinary_agreed_day', prefix: '所定労働時間外<br>', suffix: '時間', checked: false, limit: '', type: 'number', required: false, error: '', min: 0, max: 16, name: ''},
          {key: 'ordinary_legal_day', prefix: '法定労働時間外<br>', suffix: '時間', checked: false, limit: '', type: 'number', required: false, error: '', min: 0, max: 16, name: ''},
          {key: 'ordinary_agreed_month', prefix: '所定労働時間外<br>', suffix: '時間', checked: false, limit: '', type: 'number', required: false, error: '', min: 0, max: 45, name: ''},
          {key: 'ordinary_legal_month', prefix: '法定労働時間外<br>', suffix: '時間', checked: false, limit: '', type: 'number', required: false, error: '', min: 0, max: 45, name: ''},
          {key: 'ordinary_agreed_year', prefix: '所定労働時間外<br>', suffix: '時間', checked: false, limit: '', type: 'number', required: false, error: '', min: 0, max: 360, name: ''},
          {key: 'ordinary_legal_year', prefix: '法定労働時間外<br>', suffix: '時間', checked: false, limit: '', type: 'number', required: false, error: '', min: 0, max: 360, name: ''},
        ], [
          {key: 'special_agreed_day', prefix: '所定労働時間外<br>', suffix: '時間', checked: false, limit: '', type: 'number', required: false, error: '', min: 0, max: 16, name: ''},
          {key: 'special_legal_day', prefix: '法定労働時間外<br>', suffix: '時間', checked: false, limit: '', type: 'number', required: false, error: '', min: 0, max: 16, name: ''},
          {key: 'special_agreed_month', prefix: '所定労働時間外<br>', suffix: '時間', checked: false, limit: '', type: 'number', required: false, error: '', min: 0, max: 100, name: ''},
          {key: 'special_legal_month', prefix: '法定労働時間外<br>', suffix: '時間', checked: false, limit: '', type: 'number', required: false, error: '', min: 0, max: 100, name: ''},
          {key: 'special_legal_month_count', prefix: '1箇月の上限時間を<br><span style="font-size:13px">年&nbsp;</span>', suffix: '回超過', checked: false, limit: '', type: 'number', required: false, error: '', min: 0, max: 6, name: ''},
          {key: 'special_agreed_year', prefix: '所定労働時間外<br>', suffix: '時間', checked: false, limit: '', type: 'number', required: false, error: '', min: 0, max: 720, name: ''},
          {key: 'special_legal_year', prefix: '法定労働時間外<br>', suffix: '時間', checked: false, limit: '', type: 'number', required: false, error: '', min: 0, max: 720, name: ''},
        ],
      ];
    },
    APP_OPTIONS(): IAppOption[] {
      return [
        {value: 0, text: 'アプリ・ウィンドウ', appChecked: true, windowChecked: true},
        {value: 1, text: 'アプリ', appChecked: true, windowChecked: false},
        {value: 2, text: 'ウィンドウ', appChecked: false, windowChecked: true},
      ];
    },
    APP_ITEMS_TEMPLATE(): vi.IVariableInput {
      return {key: '0', name: '', type: 'text', placeholder: 'アプリ名', required: true, error: '', max: 255, disabled: true};
    },
  },
  watch: {
    'editAlertData.agreement36Checked'(newValue) {
      for (const alert36 of this.editAlert36Array) {
        for (const item of alert36.ordinarySettings) {
          item.required = newValue && item.checked;
          item.error = '';
        }
        for (const item of alert36.specialSettings) {
          item.required = newValue && item.checked;
          item.error = '';
        }
        // 特別条項の超過回数ONの場合、一般条項の法定労働時間外を必須にする
        const specialLegalCountItem = alert36.specialSettings[4];
        const ordinaryLegalItem = alert36.ordinarySettings[3];
        ordinaryLegalItem.required =
          newValue && (ordinaryLegalItem.checked || specialLegalCountItem.checked);
      }
    },
    'editAlertData.intervalChecked'(newValue) {
      this.onChangeItem(newValue, 'intervalLimit');
    },
    'editAlertData.intervalLimit'(newValue) {
      const item = this.findValidationItem('intervalLimit')
      if(item){
        item.min = newValue === '' ? 0 : 1;
      }
      this.editIntervalLimit = newValue;
    }, 
    'editAlertData.bannedappChecked'(newValue) {
      this.appitems.forEach((v) => {
        v.disabled = !newValue;
        v.error = '';
      });
    },
    'editAlertData.irregularOpChecked'(newValue) {
      this.onChangeItem(newValue, 'irregularOpCountUpper');
    },
    'editAlertData.irregularOpCountUpper'(newValue) {
      const item= this.findValidationItem('irregularOpCountUpper')
      if(item){
        item.min = newValue === '' ? 0 : 900;
      }
      this.editIrregularOpCountUpper = newValue;
    },
  },
  async mounted() {
    this.$emit('pushPath', this.$route.path);
    const api = new API();
    const res = await api.get<models.VAlertSetting>('alert/setting');
    console.log("'alert/setting res=",res);
    if (res.result) {
      this.alertData = res.data.setting;
      this.alert36Array = res.data.settings36;
      this.bannedApps = res.data.bannedApp;
    } else {
      this.$emit('change', NOC.APP.MODE.LOGIN);
    }

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    const query = this.$route.query;
    // console.log(query);
    if (query && query.edit) {
      // SPメニューの設定ボタンから遷移してきたときは編集状態にする
      if (query.edit === 'true') {
        // console.log('queryEdit');
        this.onClickEdit('WORK');
      }
      this.showDetaile = true;
    }
    // サイドメニュー用にアラート一覧取得
    // await this.getAlertList();
    // window.addEventListener('resize', this.handleResize, false);

    // 読み込み完了
    this.onload = true;
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize() {
      const width = window.innerWidth;
      // sp -> pc
      if (width >= 650) {
        if ((this.checkMode(NOC.SETTING.MODE.EDIT)) && (this.showDetaile)) {
          this.mode = NOC.SETTING.MODE.NORMAL;
          this.showDetaile = false;
          const path = '/setting/alert';
          this.$emit('pushPath', path);
          this.$router.push(path, () => { });
        }
      } else {
        if ((this.checkMode(NOC.SETTING.MODE.NORMAL) || this.checkMode(NOC.SETTING.MODE.EDIT)) && this.$route.path.startsWith('/setting/alert') && !(this.showDetaile)) {
          this.onClickCancel();

          this.showDetaile = true;
          this.onClickEdit(this.editType || 'WORK');

          const path = '/setting/alert?edit=true';
          this.$emit('pushPath', path);
          this.$router.push(path, () => { });

        }
      }
    },
    // モード判定
    checkMode(mode: string) {
      return this.mode === mode;
    },
    onClickEdit(editType: string) {
      // console.log('editType', editType);
      this.editAlertData = JSON.parse(JSON.stringify(this.alertData));
      this.editAlert36Array = [];
      this.alert36Array.forEach((v) => {
        this.add36(v);
      });
      this.editBannedApps = [];
      this.bannedApps.forEach((v) => {
        const item = this.addApp();
        Object.assign(item, v);
      });
      this.editType = editType;
      this.mode = NOC.SETTING.MODE.EDIT;
      if (window.innerWidth < 650) {
        this.showDetaile = true;
        const path = '/setting/alert?edit=true';
        this.$emit('pushPath', path);
        this.$router.push(path, () => {});
      }
      this.intervalLimit = this.alertData.intervalLimit;
      this.irregularOpCountUpper = this.alertData.irregularOpCountUpper;
    },
    formAlertBaseDataChange() {
      // 元データとデータの形式を合わせる
      const agreement36CheckedBase = Number(this.alertData.agreement36Checked);
      const agreement36CheckedEdit = Number(this.editAlertData.agreement36Checked);

      const intervalCheckedBase = Number(this.alertData.intervalChecked);
      const intervalCheckedEdit = Number(this.editAlertData.intervalChecked);

      const bannedappCheckedBase = Number(this.alertData.bannedappChecked);
      const bannedappCheckedEdit = Number(this.editAlertData.bannedappChecked);

      const irregularOpCheckedBase = Number(this.alertData.irregularOpChecked);
      const irregularOpCheckedEdit = Number(this.editAlertData.irregularOpChecked);

      // チェックボックスの比較
      const baseChecks = agreement36CheckedBase === agreement36CheckedEdit &&
                        intervalCheckedBase === intervalCheckedEdit &&
                        bannedappCheckedBase === bannedappCheckedEdit &&
                        irregularOpCheckedBase === irregularOpCheckedEdit;

      const alert36Changed = this.compareAlert36Changes();
      const alertBannedAppChanged = this.compareBannedAppsChanges();
      const intervalLimitChanged = this.compareIntervalLimitChanges();
      const irregularOpCountChanged = this.compareIrregularOpCountChanges();

      if (baseChecks && alert36Changed && alertBannedAppChanged && intervalLimitChanged && irregularOpCountChanged) {
        this.formDataChangeFlgModal = false;
      } else {
        this.formDataChangeFlgModal = true;
      }
      if (this.formDataChangeFlgModal) {
        // 編集ボタン押下後と差異があれば、編集中データのモーダルを表示する
        this.formDataChangeFlgModal = true;
      } else {
        this.formDataChangeFlgModal = false;
        this.selectBack();
      }
    },
    selectBack() {
      // URLをもとの状態（アラート通知画面のURL）に戻す
      const path = '/alert';
      this.$emit('pushPath', path);
      this.$router.push(path, () => {});
      this.editAlertData = new models.CAlertSetting();
      for (const alert36 of this.editAlert36Array) {
        alert36.ordinarySettings = [];
        alert36.specialSettings = [];
      }
      this.editAlert36Array = [];
      this.editBannedApps = [];
      this.appitems = [];
      this.mode = NOC.SETTING.MODE.NORMAL;
      this.editType = '';
      this.showDetaile = false;
    },
    onClickCancel() {
      this.editAlertData = new models.CAlertSetting();
      for (const alert36 of this.editAlert36Array) {
        alert36.ordinarySettings = [];
        alert36.specialSettings = [];
      }
      this.editAlert36Array = [];
      this.editBannedApps = [];
      this.appitems = [];
      this.mode = NOC.SETTING.MODE.NORMAL;
      this.editType = '';
      this.showDetaile = false;
    },
    onClickCancelEdit() {
      this.editAlertData = new models.CAlertSetting();
      for (const alert36 of this.editAlert36Array) {
        alert36.ordinarySettings = [];
        alert36.specialSettings = [];
      }
      this.editAlert36Array = [];
      this.editBannedApps = [];
      this.appitems = [];
      this.mode = '';
      this.editType = '';
      this.showDetaile = false;
      const path = '/alert';
      this.$emit('pushPath', path);
      this.$router.push(path, () => {});
    },
    async onClickRegist(editType: string, spFlag: boolean) {
      const errorNum = this.checkErrors(editType);
      if (errorNum < 1) {
        const api = new API();
        let res;
        switch (editType) {
          // 労働時間アラート
          case 'WORK': {
            const filtered36Array = this.editAlert36Array.filter((v) => {
              return !v.delFlg || v.alert36ID;
            });
            res = await api.put<models.VAlertSetting, models.VAlertSetting>('alert/setting/editwork', {
              setting: this.editAlertData,
              settings36: filtered36Array,
              bannedApp: [],
            });
            break;
          }
          // 禁止アプリ通知
          case 'APP': {
            const filteredBannedApps = this.editBannedApps.filter((v) => {
              return !v.delFlg || v.bannedAppID; // 新規追加かつ削除済みは除外
            });
            res = await api.put<models.VAlertSetting, models.VAlertSetting>('alert/setting/editapp', {
              setting: this.editAlertData,
              settings36: [],
              bannedApp: filteredBannedApps,
            });
            break;
          }
          // 異常操作回数通知
          case 'OPERATION': {
            res = await api.put<models.VAlertSetting, models.VAlertSetting>('alert/setting/irregular_op', {
              setting: this.editAlertData,
              settings36: [],
              bannedApp: [],
            });
            break;
          }
        }
        if (res && res.result) {
          this.alertData = res.data.setting;
          this.alert36Array = res.data.settings36;
          this.bannedApps = res.data.bannedApp;
          this.editAlert36Array = [];
          this.editBannedApps = [];
          this.appitems = [];
          if (spFlag) {
            this.showDetaile = false;
            // const path = '/alert';
            // const path = '/setting/alert';
            const path = window.innerWidth < 650 ? '/alert' : '/setting/alert';
            this.$emit('pushPath', path);
            this.$router.push(path, () => { });
          }
          this.mode = NOC.SETTING.MODE.NORMAL;
        } else {
          this.$emit('info', '登録できませんでした。');
        }
      }
    },
    onChangeItem(value: boolean, type: keyof models.IAlertSetting) {
      const item = this.findValidationItem(type)
      if(item){
        item.required = value;
        item.error = '';
      }
    },
    // 36協定通知関連 --------------------------------------------------------
    onChange36(idx: number) {
      // 職種別設定の更新フラグ設定
      const edited36 = this.editAlert36Array[idx];
      edited36.updFlg = edited36.alert36ID ? true : false;
    },
    onChange36Check(alert36Idx: number, item: models.IAlertSettingUnit) {
      // チェックボックス変更時処理
      item.required = item.checked && this.editAlertData.agreement36Checked;
      item.error = '';
      // 特別条項の超過回数ONの場合、一般条項の法定労働時間外を必須にする
      if (item.key === 'special_legal_month_count') {
        const ordinaryLegalItem = this.editAlert36Array[alert36Idx].ordinarySettings[3];
        ordinaryLegalItem.required =
          this.editAlertData.agreement36Checked && (ordinaryLegalItem.checked || item.checked);
      }
      // 更新フラグ設定
      this.onChange36(alert36Idx);
    },
    onClickAdd36() {
      this.current36Index = -1;
      this.selectedJobs = [];
      this.dialogJobSelect = true;
    },
    add36(value?: models.CAlert36Setting): models.CAlert36Setting {
      let newItem;
      if (value) {
        newItem = JSON.parse(JSON.stringify(value));
        for (let i = 0; i < newItem.ordinarySettings.length; i++) {
          const unit = newItem.ordinarySettings[i];
          const valid = this.SETTINGS_36_TEMPLATE[0][i];
          unit.min = valid.min;
          unit.max = valid.max;
        }
        for (let i = 0; i < newItem.specialSettings.length; i++) {
          const unit = newItem.specialSettings[i];
          const valid = this.SETTINGS_36_TEMPLATE[1][i];
          unit.min = valid.min;
          unit.max = valid.max;
        }
      } else {
        newItem = new models.CAlert36Setting();
        newItem.ordinarySettings = JSON.parse(JSON.stringify(this.SETTINGS_36_TEMPLATE[0]));
        newItem.specialSettings = JSON.parse(JSON.stringify(this.SETTINGS_36_TEMPLATE[1]));
      }
      this.editAlert36Array.push(newItem);
      return newItem;
    },
    onClickDelete36(itemIndex: number) {
      this.current36Index = itemIndex;
      this.dialogDelete36 = true;
    },
    delete36(idx: number) {
      const edited36 = this.editAlert36Array[idx];
      const itemsOrdinary = edited36.ordinarySettings;
      for (const item of itemsOrdinary) {
        item.error = '';
        item.required = false;
      }
      const itemsSpecial = edited36.specialSettings;
      for (const item of itemsSpecial) {
        item.error = '';
        item.required = false;
      }
      edited36.delFlg = true;
      // ダイアログを閉じる
      this.current36Index = -1;
      this.dialogDelete36 = false;
    },
    // 36協定通知 職種関連 -----------------------------------------------
    // 職種変更ボタン
    onClickChangeJobs(itemIndex: number) {
      this.current36Index = itemIndex;
      this.selectedJobs = this.editAlert36Array[itemIndex].jobs;
      this.dialogJobSelect = true;
    },
    // 職種ダイアログの選択済み職種の×ボタン
    onClickDeleteJob(value: number) {
      this.selectedJobs = this.selectedJobs.filter((v) => v.value !== value);
    },
    // 職種ダイアログの決定ボタン
    onClickConfirmJobs(idx: number) {
      if (idx !== -1) {
        // 職種変更
        this.editAlert36Array[idx].jobs = this.selectedJobs;
        this.onChange36(idx);
      } else {
        // 職種別設定追加
        const new36 = this.add36();
        new36.jobs = this.selectedJobs;
      }
      this.selectedJobs = [];
      // ダイアログを閉じる
      this.current36Index = -1;
      this.dialogJobSelect = false;
    },
    addJobs(value: string) {
      const newJobs: ISelectOption[] = [];
      const jobKeyStrs = value.split(',');
      for (const jobKey of jobKeyStrs) {
        const found = this.JOBArray.find((v) => String(v.value) === jobKey);
        if (found) {
          newJobs.push(found);
        }
      }
      this.selectedJobs = newJobs;
    },
    getAvailableJobs(idx: number) {
      const jobArray = this.JOBArray.filter((v) =>
        !this.editAlert36Array.some((v2, i2) =>
          i2 !== idx && !v2.delFlg && v2.jobs.some((v3) => v3.value === v.value)));
      return jobArray;
    },
    // 禁止アプリ通知関連 --------------------------------------------------------
    onChangeApp(idx: number) {
      // 入力部品設定
      const editedApp = this.editBannedApps[idx];
      const item = this.appitems[idx];
      item.error = '';
      editedApp.updFlg = editedApp.bannedAppID ? true : false;
    },
    getAppName(value: string) {
      const result = this.APP_OPTIONS.find((v) => String(v.value) === value);
      return result ? result.text : '';
    },
    getAppType(item: models.CBannedApp) {
      if (!item) {
        return '0';
      }
      const result = this.APP_OPTIONS.find((v) =>
        Number(v.appChecked) === Number(item.appChecked) &&
        Number(v.windowChecked) === Number(item.windowChecked));
      return result ? String(result.value) : '0';
    },
    onSelectAppType(item: models.CBannedApp, value: string) {
      const result = this.APP_OPTIONS.find((v) => String(v.value) === value);
      if (result) {
        item.appChecked = result.appChecked;
        item.windowChecked = result.windowChecked;
      }
    },
    onClickDeleteApp(idx: number) {
      const editedApp = this.editBannedApps[idx];
      const item = this.appitems[idx];
      item.error = '';
      item.required = false;
      editedApp.delFlg = true;
    },
    addApp(): models.CBannedApp {
      const newItem = new models.CBannedApp();
      // init
      newItem.appChecked = true;
      newItem.windowChecked = true;
      // values
      this.editBannedApps.push(newItem);
      // validations
      const item = { ...this.APP_ITEMS_TEMPLATE }; // copy
      item.key = String(this.editBannedApps.length - 1);
      item.disabled = !this.editAlertData.bannedappChecked;
      this.appitems.push(item);
      return newItem;
    },
    // バリデーション --------------------------------------------------------
    checkErrors(editType: string): number {
      let errorNum = 0;
      /* 一斉チェック */
      switch (editType) {
        case 'WORK': {
          // 長時間残業、勤務間インターバル
          const foundItem = this.findValidationItem('intervalLimit')
          const checkItems = foundItem && (this.editAlertData.intervalLimit || this.editAlertData.intervalLimit === '') ? [foundItem] : [];
          errorNum += validation.checkValues(this.editAlertData, checkItems);

          // 36協定
          for (let i = 0; i < this.editAlert36Array.length; i++) {
            const alert36 = this.editAlert36Array[i];
            if (alert36.delFlg) {
             // 削除するものはスキップ
              continue;
            }
            // 一般条項
            for (const unit of alert36.ordinarySettings) {
              errorNum += validation.checkValue(unit.limit, unit) ? 1 : 0;
            }
            // 特別条項
            for (const unit of alert36.specialSettings) {
              errorNum += validation.checkValue(unit.limit, unit) ? 1 : 0;
            }
            this.$set(this.editAlert36Array, i, alert36);
          }
          break;
        }
        case 'APP': {
          const appNames = this.editBannedApps.map((v) => v.name);
          errorNum += validation.checkValues(appNames, this.appitems);
          break;
        }
        case 'OPERATION': {
          //異常操作回数
          const foundItem = this.findValidationItem('irregularOpCountUpper')
          const checkOperation = foundItem && (this.editAlertData.irregularOpCountUpper || this.editAlertData.irregularOpCountUpper === '') ? [foundItem] : [];
          errorNum += validation.checkValues(this.editAlertData, checkOperation);
          break;
        }
      }
      return errorNum;
    },
    // util
    getMonthFirst(value: number) {
      const option = this.MONTH_FIRST_OPTIONS.find((v) => v.value === value);
      return option ? option.text : '未選択';
    },
    getDateString(dateStr: string) {
      const date = new Date(dateStr);
      return isNaN(date.getTime()) ? '未選択' : `${date.getMonth() + 1}月${date.getDate()}日`;
    },
    // async getAlertList() {
    //   const api = new API();
    //   const param = {
    //     currentAlertID: this.minAlertID,
    //   } as alertModels.VNewsAlertPagination;
    //   const res = await api.get<alertModels.VNewsAlert>('alert', param);
    //     // console.log(res)
    //   if (res.result) {
    //     if (res.data.alert.length > 0) {
    //       this.alertList = this.alertList.concat(res.data.alert);
    //       this.minAlertID = res.data.alert.reduce((a, b) =>
    //         a.alertID < b.alertID ? a : b,
    //       ).alertID;
    //     }
    //   } else {
    //     this.$emit('change', NOC.APP.MODE.LOGIN);
    //   }
    // },

    // 36協定を比較
    compareAlert36Changes() {
      if (this.editAlert36Array.length === this.alert36Array.length) {
        for (let i = 0; i < this.editAlert36Array.length; i++) {
          if (this.editAlert36Array[i].alert36ID === this.alert36Array[i].alert36ID
            && this.editAlert36Array[i].monthFirst === this.alert36Array[i].monthFirst
            && this.editAlert36Array[i].yearFirst === this.alert36Array[i].yearFirst
            && this.compareSettings(this.editAlert36Array[i].ordinarySettings, this.alert36Array[i].ordinarySettings)
            && this.compareSettings(this.editAlert36Array[i].specialSettings, this.alert36Array[i].specialSettings)
            && this.compareJobs(this.editAlert36Array[i].jobs, this.alert36Array[i].jobs)
            && !this.editAlert36Array[i].delFlg
          ) {
            continue;
          } else {
            return false;
          }
        }
        return true;
      } else {
        return false;
      }
    },

    // 設定を比較
    compareSettings(editSettings: IAlertSettingUnit[], originalSettings: IAlertSettingUnit[]): boolean {
      if (editSettings.length === originalSettings.length) {
        for (let i = 0; i < editSettings.length; i++) {
          if (editSettings[i].key === originalSettings[i].key
            && Number(editSettings[i].checked) === Number(originalSettings[i].checked)
            && editSettings[i].limit === originalSettings[i].limit
          ) {
            continue;
          } else {
            return false;
          }
        }
        return true;
      } else {
        return false;
      }
    },

    // 職種を比較
    compareJobs(editJobs: ISelectOption[], originalJobs: ISelectOption[]): boolean {
      if (editJobs.length === originalJobs.length) {
        for (let i = 0; i < editJobs.length; i++) {
          if (editJobs[i].value === originalJobs[i].value && editJobs[i].text === originalJobs[i].text) {
            continue;
          } else {
            return false;
          }
        }
        return true;
      } else {
        return false;
      }
    },

    // 禁止アプリを比較
    compareBannedAppsChanges() {
      if (this.editBannedApps.length === this.bannedApps.length) {
        for (let i = 0; i < this.editBannedApps.length; i++) {
          if (Number(this.editBannedApps[i].bannedAppID) === Number(this.bannedApps[i].bannedAppID)
          && this.editBannedApps[i].name === this.bannedApps[i].name
          && Boolean(this.editBannedApps[i].checked) === Boolean(this.bannedApps[i].checked)
          && Boolean(this.editBannedApps[i].appChecked) === Boolean(this.bannedApps[i].appChecked)
          && Boolean(this.editBannedApps[i].windowChecked) === Boolean(this.bannedApps[i].windowChecked)
          && !this.editBannedApps[i].delFlg
          ) {
            continue;
          } else {
            return false;
          }
        }
        return true;
      } else {
        return false;
      }
    },

    // インターバル比較
    compareIntervalLimitChanges() {
      if (this.intervalLimit === this.editIntervalLimit) {
        return true;
      } else {
        return false;
      }
    },
    compareIrregularOpCountChanges() {
      if (this.irregularOpCountUpper === this.editIrregularOpCountUpper) {
        return true;
      } else {
        return false;
      }
    },
    findValidationItem(search_key:  keyof models.IAlertSetting ){
	    return this.items.find((v)=> v.key === search_key);
    }
  },
});

